import dataService from 'src/app.service'

const getSubmission = id => {
  return dataService.get('/profiles/dealbook-submissions/' + id)
}

const getSubmissions = () => {
  return dataService.get('/profiles/dealbook-submissions')
}

const updateSubmission = data => {
  return dataService.patch('/profiles/dealbook-submissions', data)
}

export default {
  getSubmission,
  getSubmissions,
  updateSubmission,
}
